/** API route map: URLS.Controller.BillingTemplate */
export const BillingTemplate = {
      Name: 'BillingTemplate/',
      GetBillingTemplates: 'get-billing-templates',
      AddBillingTemplate: 'add-billing-template',
      UpdateBillingTemplate: 'update-billing-template',
      DeleteBillingTemplate: 'delete-billing-template',
};
